import React, { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ExampleImg from '../../assets/productImages/product6.png';
import ExampleGrids from '../../assets/productImages/product2.png';
import ExampleGrids2 from '../../assets/productImages/product3.png';
import ExampleGrids3 from '../../assets/productImages/product4.png';
import ExampleGrids4 from '../../assets/productImages/product4.png';
import './ProductView.css';

const productImages = [
    { src: ExampleImg, alt: 'Main product image' },
    { src: ExampleGrids, alt: 'Side view of product' },
    { src: ExampleGrids2, alt: 'Back view of product' },
    { src: ExampleGrids3, alt: 'Close-up of product material' },
    { src: ExampleGrids4, alt: 'Product styled on a model' },
];

const ProductView = () => {
    const [mainImage, setMainImage] = useState(productImages[0].src);

    const handleThumbnailClick = (src) => {
        setMainImage(src);
    };

    return (
        <div className='page__wrapper'>
            <Navbar />
            <div className='product__view-container'>
                <div className='product__images-wrapper'>
                    <div className='product__thumbnail-gallery'>
                        {productImages.map((img, index) => (
                            <img
                                key={index}
                                className={`product__thumbnail ${img.src === mainImage ? 'active' : ''}`}
                                alt={img.alt}
                                src={img.src}
                                onClick={() => handleThumbnailClick(img.src)}
                            />
                        ))}
                    </div>
                    <div className='product__main-image-container'>
                        <img
                            className='product__main-image'
                            alt='Main product view'
                            src={mainImage}
                        />
                    </div>
                </div>
                <div className='product__details-wrapper'>
                    <p className='product__brand'>Brand Name</p>
                    <h1 className='product__name'>Product Name</h1>
                    <p className='product__price'>$59.99</p>
                    <p className='product__description'>
                        This is a sample product description. It provides a detailed overview of the product, including its features, materials, and benefits. The product is designed for comfort and style, suitable for any occasion.
                    </p>
                    <div className='product__size-selector'>
                        <label htmlFor='size-select'>Select Size:</label>
                        <select id='size-select' className='size-dropdown'>
                            <option value='S'>S</option>
                            <option value='M'>M</option>
                            <option value='L'>L</option>
                            <option value='XL'>XL</option>
                        </select>
                    </div>
                    <button className='add-to-cart-btn'>Add to Cart</button>
                </div>
            </div>
        </div>
    );
};

export default ProductView;
